<template>
  <div id="single-wallet">
    <vx-card collapseAction :title="!$vs.rtl? $t(coinName) +' '+ $t('wallet'): $t('wallet') +' '+ getNameCoin(coinSymbol)[islocale]">

      <div slot="no-body" id="card-single-wallet"  class="tabs-container lg:px-6 pt-6 px-1">

        <vs-tabs :color="colorx" v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label=" واریز " icon-pack="feather" icon="icon-trending-down" @click="colorx = 'success'">
            <Deposit v-if="coin" :coin="coin" @refreshData="refreshData()"/>
          </vs-tab>
          <vs-tab label=" برداشت " icon-pack="feather" icon="icon-trending-up" @click="colorx = 'danger'">
            <Withdraw v-if="coin" :coin="coin" :dailyWithdrawalCrypto="dailyWithdrawalCrypto" :levelInfo="levelInfo" @refreshData="refreshData()"/>
          </vs-tab>
        </vs-tabs>

      </div>
    </vx-card>

    <History :coin="coinName" v-if="coinName" ref="History" class="mt-base"/>

  </div>

</template>

<script>
  import axios from '../../../axios'
  import Withdraw from "./Withdraw";
  import Deposit from "./Deposit";
  //import History from "./History";
  import History from "../../tools/history/crypto/Crypto";


  export default {
    data () {
      return {
        coinName: null,
        coinSymbol: null,
        coin: null,
        levelInfo: null,

        dailyWithdrawalCrypto: null,
        colorx: 'success',
        activeTab:0,
        selected:[],

        //filter Tabel
        filterModelOptions: [
          {text: 'deposit & withdraw', value:''},
          {text: 'deposit', value:'deposit'},
          {text: 'withdraw', value:'withdraw'}
        ],
        filterModel:'',


        historyTransaction: []
      }
    },
    computed: {
    },
    components: {
      Withdraw,Deposit,History
    },
    watch:{
      activeTab (newValue) {
        if (newValue == 0) this.$router.replace({'query': null})
        else if( this.$route.query.withdraw != 'true')
          this.$router.replace({'query': {'withdraw': 'true'}})
      }
    },
    methods:{
      refreshData(){
        this.getWallet();
        this.$refs.History.getList();
      },
      getWallet(){
        const self = this
        axios.post('/wallets/'+ this.coinName ).then(function (response) {
          self.coin = response.data.wallet
          self.levelInfo = response.data.level_info
          self.dailyWithdrawalCrypto = response.data.level_used.daily_withdrawal_crypto;
          self.$vs.loading.close('#card-single-wallet > .con-vs-loading')

        }).catch(function (error) { console.log(error); })
      },
      addLocalName () {
        const historyTransaction = this.historyTransaction
        const i18n = this.$i18n
        historyTransaction.map(function (value, key) {
          historyTransaction[key].Model_local = i18n.t(historyTransaction[key].Model)
        })
        this.historyTransaction = historyTransaction
      }
    },
    mounted () {
      this.addLocalName();
      this.$vs.loading({
        container: '#card-single-wallet',
        type: 'corners',
        scale: 2
      })
    },
    created () {
      this.coinName = this.$route.params.coinName;
      this.coinSymbol = this.getSymbolCoin(this.coinName);
      if(!this.coinSymbol){
        this.$router.push('/error-404')
        return;
      }

      this.$emit('changeRouteTitle',!this.$vs.rtl? this.$t(this.coinName) +' '+ this.$t('wallet'): this.$t('wallet') +' '+ this.getNameCoin(this.coinSymbol)[this.islocale])
      if(this.$route.meta.breadcrumb.slice(-1)[0].active){
        this.$route.meta.breadcrumb.slice(-1)[0].title = this.getNameCoin(this.coinSymbol)[this.islocale]
      }

      if (this.$route.query.withdraw == 'true') this.activeTab = 1, this.colorx = 'danger'
      this.getWallet();
    }
  }
</script>

<style lang="scss">
  #single-wallet {
    .ul-tabs .vs-tabs--li button {
      font-size: 16px;
    }

    .font-large-6 {
      font-size: 115px;
    }

    .w-130 .vs-table-text{
      min-width: 130px;
    }
    .w-300 .vs-table-text{
      width: 300px;
    }
    .w-90 .vs-table-text{
      min-width: 90px;
    }
    .w-300-break{
      width: 300px;
      word-break: break-word;
    }
    .header-table.vs-table--header{
      padding-left: 10px;
      padding-right: 10px;
    }


    .vs-input--label{
      font-size: 15px;
    }

    .input-rounded-full .input-select-con .vs-select--input {
      border-radius: 20px;
    }

    @media only screen and (max-width: 400px) {
      .con-input-search.vs-table--search{
        width: 50%;
        margin: 0px 5px 0px 5px;
      }
    }
  }
</style>
